/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import React from "react";
import { Select, MenuItem } from "@material-ui/core";
import TranslateIcon from "@material-ui/icons/Translate";
import { changeStyleWithHosting } from "utility/hosting";

import { LANG_LIST, parseAsSpwnLocaleKey } from "constants/lang";
import { PCView } from "components/common/MediaQuery";
import { withNoTranslate } from "i18n/noTranslate";
import { getLanguageType } from "i18n/weglot";

export const LanguageDropdownMenu: React.FC = () => {
  const classes = styles();
  const languageType = getLanguageType();

  /**
   * セレクトボックスで言語が変更された時の処理.
   */
  const handleChangeLang = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const lang = event.target.value;

    const parsedLang = parseAsSpwnLocaleKey(lang);

    document.cookie = `lang=${parsedLang}; path=/`;

    // NOTE: リロードしないとweglotが正しく動作しない場合があるため、リロードする
    window.location.reload();
  };

  /**
   * @todo SelectをMenuに置き換える
   * @see https://github.com/balus-co-ltd/spwn/issues/7003
   */
  return (
    <div {...withNoTranslate()} css={classes.root}>
      <PCView>
        <div css={classes.icon} aria-label={"Language"}>
          <TranslateIcon />
        </div>
      </PCView>

      <Select
        css={classes.selectbox}
        value={languageType.value}
        label={languageType.label}
        {...withNoTranslate()}
        disableUnderline={true}
        onChange={handleChangeLang}
        MenuProps={{
          getContentAnchorEl: null,
          MenuListProps: {
            ...withNoTranslate(),
          },
        }}
      >
        {LANG_LIST.map((item) => (
          <MenuItem key={item.value} value={item.value} {...withNoTranslate()}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

const styles = () => {
  const { textColor } = changeStyleWithHosting().commonSettings.header;

  return {
    root: css`
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    `,
    icon: css`
      color: ${textColor};
      svg {
        width: 0.8em;
        height: 0.8em;
        padding: 2px;
        fill: initial;
        background-color: #fff;
        border-radius: 2px;
      }
    `,
    selectbox: css`
      .MuiInputBase-input {
        padding: 7px 0 6px;
      }
      .MuiInput-input {
        padding-right: 32px;
        color: ${textColor};
        font-size: 12px;
        font-weight: bold;
        @media screen and (min-width: 768px) {
          padding-right: 0;
          font-size: 14px;
        }
      }
      input {
        display: none;
      }
      svg {
        fill: ${textColor};
      }
    `,
  };
};
